export default __webpack_public_path__ + "static/media/ivf-facility.abb1f0ab.png";